import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useGetMyAccountPointsHistory } from '@services/useGetMyAccountPointsHistory';
import { MyAccountPointsHistory } from '@components/templates/myAccount/myAccountPointsHistory';

export function MyAccountPointsHistoryPage() {
    const { t } = useTranslation();
    const { request: requestGetMyAccountPointsHistory } = useGetMyAccountPointsHistory();

    const translations = {
        title: t('my-points-component.metatags.title'),
        description: t('my-points-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myPoints,
        index: false,
    });

    useEffect(() => {
        requestGetMyAccountPointsHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <MyAccountPointsHistory />;
}
